import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import $api, { API } from "../index";
import { TConfirmationByMessage } from "../../types/application";

type TData = {
  phone: string;
  code: number;
  contestId: string;
  audioTrackId: string;
};

const getConfirmationByMessage = createAsyncThunk<
  TConfirmationByMessage,
  TData,
  { rejectValue: string }
>("getConfirmationByMessage", async (data, { rejectWithValue }) => {
  try {
    const payload = {
      phone: data.phone,
      code: Number(data.code),
      contestId: data.contestId,
      audioTrackId: data.audioTrackId,
    };

    const response = await $api.post(`${API.confirmationByMessage}`, payload);

    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.message) {
      return rejectWithValue(e.message);
    }
    return rejectWithValue("Unexpected error");
  }
});

export default getConfirmationByMessage;
